import { fromJS } from 'immutable';
import { PRIMARY_CONFIG_NAME } from '../multiConfigReportGetters';
import { toMetricKey } from '../../v2/dataset/datasetMetrics';

// Import these from the right locati
export const setColumnAliasFromMultiConfigReport = (report, columnAlias) => {
  return report.setIn(['displayParams', 'columnAlias'], columnAlias);
};

/**
 * Adds or updates a column alias in the report. Column alias allows users to rename the column headers in the report. In this setter, the columnAlias is limited to one single alias for the specific config.
 */
export const setColumnAlias = (report, configName, property, metricType, alias) => {
  const newColumnAliasKey = toMetricKey({
    property,
    type: metricType
  });
  const newColumnAlias = fromJS({
    alias,
    reportColumnName: newColumnAliasKey,
    translationKey: null
  });
  return report.updateIn(['displayParams', 'columnAlias', configName === PRIMARY_CONFIG_NAME ? 'primaryConfig' : configName], () => {
    return alias ? fromJS({}).set(newColumnAliasKey, newColumnAlias) : null;
  });
};

/**
 * Sets the column alias for a specific config based on a whole columnAlias object
 */
export const setColumnAliasByObject = (report, configName, columnAlias) => {
  return report.updateIn(['displayParams', 'columnAlias', configName === PRIMARY_CONFIG_NAME ? 'primaryConfig' : configName], () => columnAlias);
};

/**
 * Deletes all column alias associated with a config.
 */
export const deleteColumnAliasByConfigName = (report, configName) => {
  return report.deleteIn(['displayParams', 'columnAlias', configName === PRIMARY_CONFIG_NAME ? 'primaryConfig' : configName]);
};
export const setDisplayParamsAssociatedReportTemplateIdByConfigName = (report, configName, crmIndexReportTemplates) => {
  return report.setIn(['displayParams', 'associatedReportTemplateIds', configName], crmIndexReportTemplates);
};
export const setDisplayParamsShowCrmIndexMetrics = (report, showCrmIndexMetrics) => {
  return report.setIn(['displayParams', 'showCrmIndexMetrics'], showCrmIndexMetrics);
};